import { i18n } from "@/i18n";

export type NumberFormatOption = Parameters<typeof i18n.n>[1];

export function formatNumber(value: number | boolean | undefined | null, numberFormat?: NumberFormatOption) {
  if (typeof value === "string") return value;
  if (value == null) return "—";
  if (value === true) return i18n.t("words.true");
  if (value === false) return i18n.t("words.false");
  if (value == Infinity) return "∞";
  if (value == -Infinity) return "-∞";
  if (isNaN(value)) return "?";
  try {
    if (!numberFormat) return i18n.n(value);
    return i18n.n(value, numberFormat);
  } catch (e) {
    console.error("Error formatting number", value, e);
    return "??";
  }
}
